<template>
    <DsModalDialog
        v-model="onboardingModal.isOpened"
        @update:model-value="closeModalAnalytics"
        theme="dark"
        css-class="bonusomat-onboarding"
    >
        <template #content>
            <div class="bonusomat-onboarding__carousel-wrap">
                <BonusomatOnboardingCarousel v-if="onboardingModal.isOpened && onboardingData" />
            </div>
        </template>
        <template #bottom>
            <div class="bonusomat-onboarding__footer">
                <ol class="ds-carousel-indicator__dots">
                    <li
                        v-for="(page, index) in onboardingPages"
                        :key="page?.codeName"
                        class="dot"
                        :class="{ 'is-selected': index === onboardingActiveStep }"
                        @click="changeStep(index)"
                    ></li>
                </ol>
                <div class="bottom-slot-action-bar">
                    <div class="bottom-slot-action-bar__wrap">
                        <DsButton
                            type="secondary"
                            theme="dark"
                            icon-left="chevron-left"
                            v-if="onboardingActiveStep !== 0"
                            @click="stepBack"
                        >
                            Zpět
                        </DsButton>
                        <DsButton
                            v-show="!isLastStep"
                            type="primary"
                            theme="dark"
                            icon-right="chevron-right"
                            @click="stepForward"
                        >
                            Další krok
                        </DsButton>
                        <DsButton
                            v-show="isLastStep"
                            type="primary"
                            theme="dark"
                            icon-right="close"
                            @click="closeModalCtaClick"
                        >
                            Zavřít
                        </DsButton>
                    </div>
                </div>
            </div>
        </template>
    </DsModalDialog>
</template>

<script lang="ts" setup>
import { computed, onMounted, watch } from "vue";

import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import BonusomatOnboardingCarousel from "./bonusomat-onboarding-carousel.vue";

import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";

const {
    onboardingData,
    onboardingModal,
    onboardingActiveStep,
    onboardingOpenStep,
    openBonusomatOnboarding,
    wasOnboardingAlreadyVisited,
    setOnboardingAlreadyVisited,
} = useBonusomatOnboarding();

let onboardingAnalyticsPushedSteps: number[] = [];

const onboardingPages = computed(() => onboardingData.value?.pages);

const isLastStep = computed(() => onboardingActiveStep.value === onboardingPages.value.length - 1);

onMounted(async () => {
    if (wasOnboardingAlreadyVisited()) return;

    setOnboardingAlreadyVisited();
    await openBonusomatOnboarding("", true);

    BonusomatDatalayer.pushOnboardingImpression(onboardingPages.value[0]?.title, 0);
    onboardingAnalyticsPushedSteps.push(0);
});

watch(onboardingModal, () => {
    if (typeof onboardingModal?.page === "string") {
        const index = onboardingPages.value?.findIndex((page) => page.codeName === onboardingModal?.page);

        onboardingActiveStep.value = index >= 0 ? index : onboardingActiveStep.value;
    }

    if (typeof onboardingModal?.page === "number") {
        onboardingActiveStep.value = onboardingModal?.page;
    }

    onboardingModal.page = null;
});

watch(onboardingActiveStep, (newStep) => {
    if (!onboardingAnalyticsPushedSteps.includes(newStep)) {
        BonusomatDatalayer.pushOnboardingImpression(onboardingData.value.pages[newStep]?.title, newStep);
        onboardingAnalyticsPushedSteps.push(newStep);
    }
});

const stepForward = () => {
    if (onboardingActiveStep.value === onboardingPages.value?.length - 1) return;

    onboardingOpenStep(onboardingActiveStep.value + 1);
};

const stepBack = () => {
    if (onboardingActiveStep.value === 0) return;

    onboardingOpenStep(onboardingActiveStep.value - 1);
};

const changeStep = (step: number) => {
    onboardingOpenStep(step);
};

const closeModalAnalytics = () => {
    BonusomatDatalayer.pushOnboardingClose(
        onboardingData.value.pages[onboardingActiveStep.value]?.title,
        onboardingActiveStep.value
    );
    onboardingAnalyticsPushedSteps = [];
};

const closeModalCtaClick = () => {
    onboardingModal.isOpened = false;
    closeModalAnalytics();
};
</script>
